module.exports = __webpack_public_path__ + "img/happy 1-3.22d0dc65.png";